import React, { useState, useRef, useEffect } from "react";
import * as Mui from "@mui/material";
import { themes, scrollTop } from "services/constants";
import { tableRowSx } from "services/constants";
import { tooltipStyleProps } from "services/constants/Styles";
import { InfoMessage } from "components/CustomComponents/CustomButton";
export const LeaveHistory = ({ leaveCreditDebitDetails, masterData }) => {
  const [leavePage, setLeavePage] = useState(0);
  const [leaverowsPerPage, setLeaveRowsPerPage] = useState(25);
  const handleChangeLeavePage = (event, newPage) => {
    setLeavePage(newPage);
  };
  const containerRef = useRef(null);

  const handleChangeLeaveRowsPerPage = (event) => {
    setLeaveRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [leavePage]);

  return (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.TableContainer
          ref={containerRef}
          sx={{
            height: "100%",
            overflowY: "auto",
            marginTop: 2,
            marginLeft: "auto",
            marginRight: "auto",
            minWidth: "90%",
            maxWidth: "100%",
            ml: 2,
            mr: 2,
          }}
        >
          <Mui.Table className="border" sx={{ borderRadius: "20px" }}>
            <Mui.TableHead
              sx={{
                backgroundColor: themes.primary,
              }}
            >
              <Mui.TableRow sx={tableRowSx}>
                <Mui.TableCell className="column-cell">
                  <Mui.Typography fontWeight={"bold"}>Date</Mui.Typography>
                </Mui.TableCell>
                <Mui.TableCell className="column-cell">
                  <Mui.Typography fontWeight={"bold"}>
                    Leave Type
                  </Mui.Typography>
                </Mui.TableCell>
                <Mui.TableCell className="column-cell">
                  <Mui.Typography fontWeight={"bold"}>
                    Description
                  </Mui.Typography>
                </Mui.TableCell>
                <Mui.TableCell className="column-cell">
                  <Mui.Typography fontWeight={"bold"}>Credit</Mui.Typography>
                </Mui.TableCell>
                <Mui.TableCell className="column-cell">
                  <Mui.Typography fontWeight={"bold"}>Debit</Mui.Typography>
                </Mui.TableCell>
                <Mui.TableCell className="column-cell">
                  <Mui.Typography fontWeight={"bold"}>
                    Credit / Debit By
                  </Mui.Typography>
                </Mui.TableCell>
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {leaveCreditDebitDetails?.length === 0 ? (
                <InfoMessage dataLength={masterData} />
              ) : (
                leaveCreditDebitDetails
                  ?.slice(
                    leavePage * leaverowsPerPage,
                    leavePage * leaverowsPerPage + leaverowsPerPage
                  )
                  .map((leave) => (
                    <>
                      <Mui.TableRow key={leave.id} sx={tableRowSx}>
                        <Mui.TableCell className="column-cell">
                          {leave.date}
                        </Mui.TableCell>
                        <Mui.TableCell className="column-cell">
                          {leave.leave_type_name}
                        </Mui.TableCell>
                        <Mui.TableCell
                          className="column-cell"
                          sx={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            maxWidth: 100,
                          }}
                        >
                          <Mui.Tooltip
                            arrow
                            slotProps={tooltipStyleProps}
                            title={leave.description}
                          >
                            {leave.description}
                          </Mui.Tooltip>
                        </Mui.TableCell>
                        <Mui.TableCell className="column-cell">
                          {leave?.credit || leave?.credit === 0
                            ? leave?.credit
                            : 0}
                        </Mui.TableCell>
                        <Mui.TableCell className="column-cell">
                          {leave?.debit || leave?.debit === 0
                            ? leave?.debit
                            : 0}
                        </Mui.TableCell>
                        <Mui.TableCell className="column-cell">
                          {leave.createdby ? leave.createdby : "N/A"}
                        </Mui.TableCell>
                      </Mui.TableRow>
                    </>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
          {leaveCreditDebitDetails?.length > 25 ? (
            <Mui.TablePagination
              sx={{ marginRight: 7 }}
              className="custom-pagination"
              rowsPerPageOptions={[25, 50, 75, 100]}
              component="div"
              count={leaveCreditDebitDetails?.length}
              rowsPerPage={leaverowsPerPage}
              page={leavePage}
              onPageChange={handleChangeLeavePage}
              onRowsPerPageChange={handleChangeLeaveRowsPerPage}
            />
          ) : null}
        </Mui.TableContainer>
      </Mui.Grid>
    </React.Fragment>
  );
};
